import {
  scrollbarStyle,
  convertToLocalStyle,
  inputFieldStyle,
} from '@bingads-webui-campaign-react/common-styles';
import {
  getImportOptionsFormStyle,
  getImportSummaryTooltipOverrideStyle,
  getImportTableOverrideStyle,
} from '@bingads-webui-campaign-react/imports-shared-styles';
import { CalloutWidth } from '../constants';

export const getImportCalloutStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '#import-settings-callout, #import-summary-callout': {
    maxWidth: 'unset',
    width: CalloutWidth,
    ...convertToLocalStyle(scrollbarStyle({ palette })),

    '& .arrow': {
      boxShadow: 'none',
      border: 'none',
    },

    '& .popover-content': {
      padding: 0,

      '& .ba-backbone-instance-wrapper': {
        margin: [0, 24, 20],
        textAlign: 'left',
      },
    },
  },

  '#import-settings-callout .ba-backbone-instance-wrapper': {
    height: 300,
    overflowY: 'auto',
    overflowX: 'hidden',
    ...getImportOptionsFormStyle({ palette }),
    ...convertToLocalStyle(inputFieldStyle({ palette, iconFontFamily })),
  },
  '#import-summary-callout': {
    '& .popover-content': {
      '& .ba-backbone-instance-wrapper': {
        '& .panel': {
          border: 'none',
          boxShadow: 'none',
          marginBottom: 0,

          '& .panel-heading, & .panel-header': {
            padding: [12, 18, 15, 0],
          },

          '& .panel-body': {
            padding: 0,
            maxHeight: 300,
            overflowY: 'auto',
            overflowX: 'hidden',
          },

          '& .panel-footer': {
            padding: 0,
            border: 'none',
          },
        },
        ...getImportSummaryTooltipOverrideStyle({ palette }),
        ...getImportTableOverrideStyle({ palette }),
      },
    },
  },
});
